export const CREATE_EVENT_COMPLETED = "project/events/createEventCompleted";

export const GET_ALL_EVENTS_COMPLETED = "project/events/getAllEventsCompleted";
export const SAVE_NOTIFICATION_COMPLETED = "project/events/saveNotificationCompleted";

export const MARK_AS_READ_COMPLETED = "project/events/markAsReadCompleted";
export const SEND_NOTIFICATION_TO_USER_COMPLETED = "project/events/sendNotificationToUserCompleted";
export const GET_NOTIFICATIONS_FOR_USER_COMPLETED = "project/events/getNotificationsForUserCompleted";
export const GET_EVENT_DETAILS_COMPLETED = "project/events/getEventDetailsCompleted";
export const DELETE_EVENT_COMPLETED = "project/events/deleteEventCompleted";